import { Button } from "@made-people/blueprint-button";
import { Heading } from "@made-people/blueprint-heading";
import { useTranslate } from "@made-people/grease-translations";
import { useGeneralSettings } from "../hooks/use-general-settings";
import { StoryblokComponent } from "@made-people/grease-storyblok";
import { SbBlokData } from "@storyblok/js";

/**
 * Represents a 404 page.
 */
export const NotFoundRoute = () => {
  const translate = useTranslate();
  const pageNotFoundComponents = useGeneralSettings()?.pageNotFoundContent;

  return (
    <div>
      <div className="h-fit py-20 lg:max-h-[40vh] w-full flex flex-col justify-center items-center gap-4 lg:gap-6 px-6 border-b border-background-surface-2 max-w-screen-page-max-width mx-auto">
        <Heading
          heading={translate("Page_Not_Found_Heading")}
          lead={translate("Page_Not_Found_Text")}
          className="text-center"
          variants={{
            headingSize: "2xl",
          }}
        />
        <Button as="a" link={{ href: "" }} label={translate("Go_To_Home")} />
      </div>
      {pageNotFoundComponents &&
        pageNotFoundComponents.map((component: SbBlokData, index: number) => (
          <StoryblokComponent key={index} blok={component} />
        ))}
    </div>
  );
};
